export default {
  forSale: false,
  viewable: true,
  title: 'Áfangi GHIJ',
  key: 'afangi-ghij',
  rect: {
    className: 'bg-dark text-white',
    props: {
      transform: 'translate(490, 1320)  scale(0.7)',
      width: 500,
      height: 130,
    },
  },
  path: {
    d: 'M396.57 1384.43l45.86-1.93 51.64-4.71 52.5-6.65 129-18.43 347.79-52.39 18-26.68-82.61-17.35 128.33-29.5-4.9-66.93 13.18-4.18v-15.43l85.9-18.24 15.19 2.09 29.62-6.78 38.47 6.75 1.07 17.25 4.39-.64 12.64 9.11 32.9-6.86-1-37.82 8.68-4.07v-17.79l18.64-8 55.77 1.64 1 18.08 39.62 1.69 44.44-15.51v-5l-7.69-.15-1-12h-10.29l-.64-17.68-19-8.68-43.4 13.34-3.21-.48-.16-11.41-14.3-7.93s-7.93 1.39-8.25 1.39-6.43-3-6.43-3l-30 6.86-20.9 11.79-.53 11.68-7.18 2-34.82-6.21-47.79 8.3-21.69-3.21.16-5.63-14.95-1.77L1145 1062l-1.13 6.59-47.87-7.89-.8-8.84-48.2-17.36-9 .32-1.12-11.89-14-9-27.17-4.72-26.78 10.72.64 15.43s-18-1.29-18.86-1.5-47.35-1.29-47.35-1.29l.43 7.5-57.22 2.14-1.71-20.78-16.29-6.43-.21-10.71-15.65-2.15-6.85-85.28-9.22-2.57-33.64 5.57v7.71l-6.86-.64v-5.57l-188.57-31.07-29.14 3.85 2.36 22.29-6.43.64 10.55 98-25.39 3.54 3.21 34.23-4.66.64 2.57 29.9 1.13 17-24.77 4.19-290.41 32.79v28.5l-29.36-6-46.18 22.6v10.4S16 1203.68 16.64 1203.57s0 2.89 0 2.89L0 1207.91v163L242.29 1387l26.35 1.07s21.54.16 22 0 27.16-.64 27.16-.64l26-.48 25.39-1z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/sementsreitur/T-GHIJ.jpg'),
      width: 5272,
      height: 2962,
    },
    list: [
      {
        lod: 'J2',
        d: 'M2712.43 2667.38L2565.86 2962h160.39l550.13-164.34 79.23-23.3 77.46-35.36 38.57-22.02 48.86-30.37 52.71-38.15 25.93-20.57 31.82-29.57 45.33-48.32 21.32-24.64 21.32-28.07 19.66-28.29 19.29-29.09 30.37-63-782.68-298.77-293.14 589.24z',
      },
      {
        lod: 'J1',
        d: 'M4093.29 1380.45L3188.86 1333l-42.5 169.36h-4.07l-9.65 54H3129l-5.79 40.5-117.64 481.28 782.68 298.77 19.93-47.73 285.11-948.73z',
      },
      {
        lod: 'I1',
        d: 'M3123.21 1596.86l5.79-40.5h3.64l9.65-54h4.07l42.5-169.36-654.18-34.32-88.39 157.18-53.36-2.79-83.25 128.95-22.18 3.05L2085 1898.3l4.82 28.77-11.41 16.88-21.7-8.04-69.91 69.75-50.94 115.55 14.3 53.68 3.86.65 5.3 19.76 4.66 2.74 5.09 17.03L1494.86 2962h1071l146.57-294.62 293.14-589.24 117.64-481.28z',
      },
      {
        lod: 'H1',
        d: 'M1726.93 1985.57l-171.22-80.14-159.85-75-119.15-81-233.14-161.57L1416.86 1149l164.57 5.14 45-53.57 166.28 62.57 36.86 1.5 3.22-2.68 13.07 3.54 423 17.57-541.93 802.5z"',
      },
      {
        lod: 'G7',
        d: 'M3392.89 224.14l2.57-19.93-16.71-47.25 5.46-92.57-221.36 9.55 36.88 230.75 20.23-.83 62.68-1.61 44.36-4.18 50.46-8.68 58.83-13.18-43.4-52.07z',
      },
      {
        lod: 'G6',
        d: 'M3143.36 74.79L2973 72.64l-32.79 231.22 92.68 2.89 147.86-1.29 18.98-.77-36.88-230.75-19.49.85z',
      },
      {
        lod: 'G5',
        d: 'M3415.71 557.14l-15.42 111-376.4-21.96-337.5-22.82v-97.4l11.57-113.46 288.97 14.14 4.82-56.57 49.18 1.61-.97 14.46 337.18 17.15 2.98 95.58 7.74.84 27.85 57.43z',
      },
      {
        lod: 'G4',
        d: 'M2548.82 301.93l-255.86-52.39-43.07 61.39-7.23 10.07 4.77 47.14-101.19 156.32 109.76 4.4-.43-25.29 10.29-63.43 41.57 1.72 14.07 169.22 27.37-.01-.7-15.65 8.76-56.28 164.14 7.5 3.43 72.22h7.29l6.1-86.15 4.82-71.03 8.36-65.25-2.25-94.5z"',
      },
      {
        lod: 'G3',
        d: 'M2249.89 310.93l-18.32-2.89-4.82-49.83-116.84-36.32-30.7 20.09-30.21 49.88v12.43l-186.43 167.57 52.29 43.33 231.38 9.27 101.19-156.32-4.77-47.14 7.23-10.07z',
      },
      {
        lod: 'G1',
        d: 'M2601.05 734.73l-2.09-39.85-55.44-3.06-2.52-56.03-18-1.29 1.5-15.64-3.43-72.22-164.14-7.5-9 57.86 2.41 36.16-27.05-.59-15.86-190.71-41.57-1.72-10.29 63.43.43 25.29-109.76-4.4-231.38-9.27-43.93-1.76-38.25-30.54-65.25-56.25-94.34-81.16-55.77-48.05-50.78-7.72-26.58 51.54-28.07-3.86-14.78 24.32 6 24.43-17.41 28.29 1.93 9.48-21.06 35.04 2.73 15.59-12.21-1.93-48.16 77.89 2.2 9.21-20.9 35.68 1.77 6.91-14.46-2.25-68.9 112.45-37.5-6.11-27.85 46.07 17.78 50.04-10.5 17.36L1263 861l-59.57 110.14 473.68 36.65 623.73 31.5 269.04 13.66 16.07-167.79h22.34l13.17-149.46-20.41-.97z',
      },
    ],
  },
}
